import { PagedMultiSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { industryService } from "../api/industryService";

const fetchConfig = laravelServiceSelectFetchConfig(industryService);
interface Props {
	name: string;
	label: string;
	required?: boolean;
}

export const IndustryMultiSelectField: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={fetchConfig} />;
};
